import { Injectable } from '@angular/core';
import { HttpInterceptorService } from '../../services';

import { YearMonthDateKey } from '.';
import { ExportService } from 'src/app/services/export/export.service';
import { ToastService } from '../../shared/services/toast/toast.service';

@Injectable({
  providedIn: 'root'
})
export class FinancialsService {
  constructor(
    private _http: HttpInterceptorService,
    private toastService: ToastService,
    private exportService: ExportService
  ) {}

  getFinancialsForCompany(PK_CompanyID: number, fromDateTimestamp: number, toDateTimestamp: number) {
    return this._http.get(`Revenues/FinanceReportForCompany/${PK_CompanyID}/${fromDateTimestamp}/${toDateTimestamp}`);
  }

  getOrdersForCompany(
    PK_CompanyID: number,
    stationID: number,
    startDate: YearMonthDateKey,
    endDate: YearMonthDateKey,
    currency: string
  ) {
    return this._http.post(`Orders/OrdersLinkedToCompany`, {
      CompanyId: PK_CompanyID,
      Currency: currency,
      Start: startDate,
      End: endDate,
      StationID: stationID
    });
  }

  downloadOrderLines = (
    companyID: number,
    stationID: number,
    startDate: YearMonthDateKey,
    endDate: YearMonthDateKey,
    currency: string,
    exportType?: string
  ) => {
    this.toastService.info('Exporting data, this may take a few seconds...');

    this.getOrdersForCompany(companyID, stationID, startDate, endDate, currency).subscribe({
      next: (data) => {
        if (data?.Orders?.length) {
          switch (exportType) {
            case 'CSV':
              this.exportService.exportCSV(
                data.Orders,
                `Orders_${startDate.Month}_${startDate.Year}-${endDate.Month}_${endDate.Year}`
              );
              break;
            case 'JSON':
              this.exportService.exportJSON(
                data.Orders,
                `Orders_${startDate.Month}_${startDate.Year}-${endDate.Month}_${endDate.Year}`
              );
              break;
            case 'Excel':
            default:
              this.exportService.simpleExcelExport(
                data.Orders,
                `Orders_${startDate.Month}_${startDate.Year}-${endDate.Month}_${endDate.Year}`,
                ['Date', 'DatePaidOut', 'InvoiceDateIssued', 'InvoiceDatePaid', 'TimeFinished', 'TimeStarted']
              );
          }
        } else {
          this.toastService.info('No orders');
        }
      },
      error: (err) => {
        this.toastService.error(err);
      }
    });
  };

  simpleExport = (data: any[], name: string) => {
    this.exportService.simpleExcelExport(data, name);
  };

  exportJSON = (data: any[], name: string) => {
    this.exportService.exportJSON(data, name);
  };
}
